import axios from "axios";
import { Navigate } from "react-router-dom";

export const load_quotes_calendar = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };
    if (data) {
      config.params = {
        ...data
      }
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/agenda_api/calendario_citas/`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}
export const load_quote_list = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };
    if (data) {
      config.params = {
        ...data
      }
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/agenda_api/citas_generales/`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}

export const load_user_summary_from_id = async (id, data) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };
    if (data) {
      config.params = {
        ...data
      }
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/agenda_api/citas_resumen/${id}`, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};



export const load_patient_grouped_quotes = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };
    if (data) {
      config.params = {
        ...data
      }
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/agenda_api/citas_por_paciente/`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}
export const load_service_grouped_quotes = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };
    if (data) {
      config.params = {
        ...data
      }
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/agenda_api/citas_por_servicio/`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}


export const load_quote_data_from_id = async (id) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/agenda_api/cita/${id}`, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const edit_quote_data_from_id = async (id, data) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };
    const body = JSON.stringify({ ...data });

    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/agenda_api/cita/${id}`, body, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const update_quote_status = async (paramsData, bodyData) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };
    if (paramsData) {
      config.params = {
        ...paramsData
      }
    }
    const body = JSON.stringify({ ...bodyData });

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/agenda_api/editar_por_grupo/`, body, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}

export const upload_quote = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };

    const body = JSON.stringify({ ...data });

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/agenda_api/citas_generales/`, body, config);

      return response.data;
    } catch (err) {
      return err;
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}

export const delete_quote_from_id = async (id) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };

    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/agenda_api/cita/${id}`, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};